export default __webpack_public_path__ + "static/media/curriculumSection1Pattern.620a6648.svg";